export default __webpack_public_path__ + "static/media/Category_Crafts_135x195.bc7c70aa.jpg";